// extracted by mini-css-extract-plugin
export default {"wrapper":"ClickableCard_wrapper__e4sGt"};